/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { GContextTypes } from '../../types';
import { GlobalContext } from '../../contexts';
import { Grid } from '@material-ui/core';
import { dublicateAlert, errorAlert, successAlert } from '../common/funcs';
import PopupLayout from '../../pages/main/PopupLayout';
import TextFieldLocal from '../shared/TextFieldLocal';
import AutoFieldLocal from '../shared/AutoFieldLocal';
import CalenderLocal from '../../components/fields/CalenderLocal';
import { useReactToPrint } from 'react-to-print';
// import { SupplierContractPrint } from '../../print';

import PrintDownloadSupplier from './PrintDownloadSupplier';

const supplierSchema = yup.object().shape({
  amount: yup.number().positive().required(),
  terms: yup.string().required(),
  desc: yup.string(),
});

const supplierResolver = { resolver: yupResolver(supplierSchema) };

const PopupSupplierForm = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  theme,
  words,
  suppliers,
  opType,
  company,
}: any) => {
  const [saving, setSaving] = useState(false);
  const [suppvalue, setSuppvalue] = useState<any>(null);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });

  const { register, handleSubmit, errors, reset, setValue } =
    useForm(supplierResolver);
  const {
    translate: { isRTL },
  }: GContextTypes = useContext(GlobalContext);

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Supplier Contract #${row?.docNo}`,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isNew && row?._id) {
      const supp = suppliers.find((s: any) => s._id === row.supplierId);
      setSuppvalue(supp);
      setStartDate(
        row.startDate
          ? new Date(row.startDate).toISOString().split('T')[0]
          : null,
      );
      setEndDate(
        row.endDate ? new Date(row.endDate).toISOString().split('T')[0] : null,
      );
      setValue('amount', row.amount);
      setValue('desc', row.desc);
      setValue('terms', row.title);
    }
  }, [row, suppliers]);

  const onSubmit = async (data: any) => {
    if (!suppvalue) {
      await errorAlert(setAlrt, isRTL);
      return;
    }
    setSaving(true);

    const variables: any = {
      _id: row?._id ? row._id : undefined,
      opType,
      time: new Date(),
      title: data.terms, // Store terms in title field
      desc: data.desc,
      amount: data.amount ? Number(data.amount) : undefined,
      startDate: startDate ? new Date(startDate) : undefined,
      endDate: endDate ? new Date(endDate) : undefined,
      supplierId: suppvalue?._id,
      supplierName: suppvalue?.name,
      supplierNameAr: suppvalue?.nameAr,
      supplierPhone: suppvalue?.phone,
    };

    const mutate = isNew ? addAction : editAction;
    const mutateName = isNew ? 'createFormOperation' : 'updateFormOperation';
    await apply(mutate, mutateName, variables);
  };

  const apply = async (mutate: any, mutateName: string, variables: any) => {
    try {
      const res = await mutate({ variables });
      if (res?.data?.[mutateName]?.ok === false) {
        await errorAlert(setAlrt, isRTL);
        setSaving(false);
        return;
      }
      closeModal();
      await successAlert(setAlrt, isRTL);
    } catch (error) {
      onError(error);
    }
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };

  const closeModal = () => {
    onClose();
    setSaving(false);
    setSuppvalue(null);
    setStartDate(null);
    setEndDate(null);
    reset();
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      reset();
      console.log(error);
    }
  };

  const printData = {
    ...row,
    supplier: suppvalue,
    suppvalue,
    terms: row?.title,
    startDate,
    endDate,
    isRTL,
  };

  const title = isRTL
    ? isNew
      ? 'إضافة عقد مورد'
      : 'تعديل عقد مورد'
    : isNew
      ? 'New Supplier Contract'
      : 'Edit Supplier Contract';

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={closeModal}
      title={title}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      maxWidth={'md'}
      saving={saving}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {!isNew && row?._id && (
            <PrintDownloadSupplier
              company={company}
              printData={printData}
              componentRef={componentRef}
              handleReactPrint={handleReactPrint}
              isRTL={isRTL}
              no={row?.docNo}
              isNew={isNew}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <AutoFieldLocal
            name="supplier"
            title={isRTL ? 'المورد' : 'Supplier'}
            words={words}
            options={suppliers}
            value={suppvalue}
            setSelectValue={setSuppvalue}
            isRTL={isRTL}
            fullWidth
            showphone
          ></AutoFieldLocal>
        </Grid>
        <Grid item xs={6}>
          <CalenderLocal
            isRTL={isRTL}
            label={isRTL ? 'تاريخ البداية' : 'Start Date'}
            value={startDate}
            onChange={(date) => setStartDate(date)}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <CalenderLocal
            isRTL={isRTL}
            label={isRTL ? 'تاريخ النهاية' : 'End Date'}
            value={endDate}
            onChange={(date) => setEndDate(date)}
            width="100%"
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldLocal
            name="amount"
            label={isRTL ? 'قيمة العقد' : 'Contract Value'}
            register={register}
            errors={errors}
            row={row}
            type="number"
            fullWidth
            mb={0}
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldLocal
            name="terms"
            label={isRTL ? 'شروط العقد' : 'Contract Terms'}
            register={register}
            errors={errors}
            row={row}
            multiline
            rows={4}
            fullWidth
            mb={0}
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldLocal
            name="desc"
            label={isRTL ? 'ملاحظات' : 'Notes'}
            register={register}
            errors={errors}
            row={row}
            multiline
            rows={2}
            fullWidth
            mb={0}
          />
        </Grid>
      </Grid>

      {/* Hidden Print Component */}
      {/* {!isNew && row?._id && (
        <div style={{ position: 'absolute', left: '-999em' }}>
          <SupplierContractPrint
            company={company}
            printData={printData}
            ref={componentRef}
          />
        </div>
      )} */}
    </PopupLayout>
  );
};

export default PopupSupplierForm;
